import List from '../../containers/Salaries/List';
import Edit from '../../containers/Salaries/Edit';
import Create from '../../containers/Salaries/Create';
import Show from '../../containers/Salaries/Show';

export default { List, Edit, Create, Show };
